import type { SystemClaimPermission } from 'src/types/claims/claimsApp';

export interface LoginResponse {
  authorization: string;
  user: IUser;
  succeeded: boolean;
}

export interface PermissionsResponse {
  username: string;
  name: string;
  email: string;
  rut: string;
  profileName: string;
  claims: SystemClaimPermission;
  rol: number;
}

export interface OpenIdResponse {
  access_token: string;
  refresh_token?: string;
  id_token?: string;
  expires_in: number;
  token_type: string;
}

export interface IUser {
  userName: string;
  name: string;
  email: string;
  profileName: string;
  claims: SystemClaimPermission;
  rut: string;
  rol: number;
}

export const DefaultIUser = {
  userName: '',
  name: '',
  email: '',
  profileName: '',
  claims: {} as SystemClaimPermission,
  rut: '',
  rol: 0,
};
